import { z } from 'zod'

export const FileDtoSchema = z.object({
  file_id: z.string(),
  filename: z.string(),
  file_type: z.string(),
  file_size: z.number(),
  uploaded_at: z.string(),
  expires_at: z.string().optional(),
  parsing_status: z.enum(['pending', 'processing', 'completed', 'failed', 'unknown']),
  is_excluded: z.boolean().optional(),
})

export const FilePoolResponseFilesDtoSchema = z.object({
  success: z.boolean(),
  total: z.number(),
  files: z.array(FileDtoSchema),
})

export const FileUploadUrlResponseDtoSchema = z.object({
  upload_url: z.string(),
  file_id: z.string(),
  method: z.string(),
})

export const FilePoolUploadConfirmationResponseDtoSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  file: FileDtoSchema,
})

export const FileResponseDtoSchema = z.object({
  success: z.boolean(),
  file: FileDtoSchema,
  parsed: z.boolean(),
  error_message: z.string().nullish(),
  content_available: z.boolean(),
})

export const FileStructureSectionDtoSchema = z.object({
  id: z.string(),
  type: z.enum(['heading', 'text', 'table']),
  caption: z.string().nullish(),
  get children() {
    return z.array(FileStructureSectionDtoSchema)
  },
})

export const FileStructureResponseDtoSchema = z.object({
  success: z.boolean(),
  file_id: z.string(),
  filename: z.string(),
  sections: z.array(FileStructureSectionDtoSchema),
})

export const FileDeleteResponseDtoSchema = z.object({
  success: z.boolean(),
  message: z.string(),
})

export const FileExclusionResponseDtoSchema = z.object({
  success: z.boolean(),
  file_id: z.string(),
  is_excluded: z.boolean(),
})

export const FileDownloadUrlResponseDtoSchema = z.object({
  success: z.boolean(),
  file_id: z.string(),
  filename: z.string(),
  download_url: z.string().url(),
  expires_in: z.number(),
})

export const FileRenewResponseDtoSchema = z.object({
  success: z.boolean(),
  file_id: z.string(),
  uploaded_at: z.string(),
  expires_at: z.string(),
})

export type FileDto = z.infer<typeof FileDtoSchema>

export type FilePoolResponseFilesDto = z.infer<typeof FilePoolResponseFilesDtoSchema>

export type FileUploadUrlResponseDto = z.infer<typeof FileUploadUrlResponseDtoSchema>

export type FilePoolUploadConfirmationResponseDto = z.infer<
  typeof FilePoolUploadConfirmationResponseDtoSchema
>

export type FileResponseDto = z.infer<typeof FileResponseDtoSchema>

export type FileDeleteResponseDto = z.infer<typeof FileDeleteResponseDtoSchema>

export type FileExclusionResponseDto = z.infer<typeof FileExclusionResponseDtoSchema>

export type FileStructureSectionDto = z.infer<typeof FileStructureSectionDtoSchema>

export type FileStructureResponseDto = z.infer<typeof FileStructureResponseDtoSchema>

export type FileDownloadUrlResponseDto = z.infer<typeof FileDownloadUrlResponseDtoSchema>

export type FileRenewResponseDto = z.infer<typeof FileRenewResponseDtoSchema>
